<template>
    <div class="amount-input-container">
      <div class="header">
        <div class="back-icon" @click="goBack">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="title">获取待充值账号</div>
        <div class="placeholder"></div>
      </div>
      <div class="content-container">
        <div class="content">
          <div class="status-container">
              <img v-if="status === 'loading'" src="@/assets/img-loading.png" class="status-img loading" alt="加载中">
              <img v-if="status === 'success'" src="@/assets/img-success.png" class="status-img success" alt="成功">
              <img v-if="status === 'error'" src="@/assets/img-error.png" class="status-img error" alt="错误">
              <img v-if="status === 'timeout'" src="@/assets/img-timeout.png" class="status-img timeout" alt="超时">
          </div>
          <!-- 显示提示信息 -->
          <div class="tip-message" :class="status">{{ tipMessage }}</div>
          <div class="input-group">
            <input 
              type="text" 
              id="inputTarget" 
              v-model="inputTarget" 
              :disabled="isGameIdTwo || isGameIdOne"
              placeholder="正在获取，请稍后..."
              @input="validateinputTarget"
              min="1" 
              step="1"
            >
          </div>
          
        </div>
      </div>
      <!-- 根据条件控制按钮显示和禁用状态 -->
      <button 
        v-if="checkOrderCount < 20"
        @click="submitAmount" 
        class="submit-button"
        :class="{ 'disabled-button': orderStatus < 2 }"
        :disabled="orderStatus < 2"
      >复制并跳转</button>
      <div v-if="showRetryButton">
        <button @click="retryOperation" class="submit-button">重新操作</button>
      </div>

              <div class="use-instructions">
          <div class="use-instructions-title">使用说明</div>
          <div class="use-instructions-content">
            <van-swipe 
              class="instruction-swipe" 
              :autoplay="5000" 
              indicator-color="#3F9FFF"
              :show-indicators="true"
            >
              <van-swipe-item>
                <div class="instruction-item">
                  <div class="instruction-step">第一步</div>
                  <img src="@/assets/step1.webp" alt="第一步示意图" class="instruction-img">
                  <div class="instruction-text">点击弹窗中的【打开】按钮，跳转至商品详情页面</div>
                </div>
              </van-swipe-item>
              <van-swipe-item>
                <div class="instruction-item">
                  <div class="instruction-step">第二步</div>
                  <img src="@/assets/step2.webp" alt="第二步示意图" class="instruction-img">
                  <div class="instruction-text">点击商品详情页面中的【立即购买】按钮，进入支付页面</div>
                </div>
              </van-swipe-item>
              <van-swipe-item>
                <div class="instruction-item">
                  <div class="instruction-step">第三步</div>
                  <img src="@/assets/step3.webp" alt="第三步示意图" class="instruction-img">
                  <div class="instruction-text">将复制的邮箱输入进入框，付款即可</div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
    </div>
    
  </template>
  
  <script>
  import axios from 'axios';
  // import md5 from 'js-md5';
  // 引入Vant轮播组件
  import { Swipe, SwipeItem } from 'vant';
  
  export default {
    components: {
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem
    },
    data() {
      return {
        inputTarget: '',
        nextRul: '',// 新增变量用于存储下一个 URL
        isGameIdTwo: true,
        isGameIdOne: false,
        gameid: null,
        id: null,
        orderId: null,
        urlAmount: null,
        payChannelId: null,
        inputAmount: '',
        checkOrderCount: 0,
        showRetryButton: false,
        orderStatus: -1, // 新增订单状态
        status: 'loading', // 当前状态：loading, success, error, timeout
        tipMessage: '' // 新增提示信息
      };
    },
    async mounted() {
      const urlParams = new URLSearchParams(window.location.search);
      this.gameid = urlParams.get('gameid');
      this.id = urlParams.get('id');
      this.urlAmount = urlParams.get('amount');
      this.payChannelId = urlParams.get('paychannelid');
      this.orderId = urlParams.get('orderId');
      // 在页面挂载时调用 startCheckOrder 方法
      this.startCheckOrder();
      document.body.style.margin = '0 auto';
    },
    beforeDestroy() {
      // 清理body样式
      document.body.style.margin = '';
    },
    methods: {
      // 设置状态和提示信息
      setStatus(status, message) {
        this.status = status;
        this.tipMessage = message;
        
        // 根据状态控制UI状态
        switch(status) {
          case 'loading':
            this.showRetryButton = false;
            break;
          case 'success':
            this.showRetryButton = false;
            break;
          case 'error':
            this.showRetryButton = false;
            break;
          case 'timeout':
            this.showRetryButton = true;
            break;
        }
      },
      goBack() {
        this.$router.back();
      },
      validateinputTarget() {
        // 允许输入空值，移除原有的验证逻辑
      },
      async submitAmount() {
        if (!this.inputTarget.trim()) {
          this.setStatus('error', '获取待充值账号失败，请重试');
          return;
        }
        
        try {
          // 将 inputTarget 的值复制到剪贴板
          await navigator.clipboard.writeText(this.inputTarget);
          console.log('内容已复制到剪贴板');
        } catch (err) {
          console.error('复制到剪贴板失败:', err);
          this.setStatus('error', '复制待充值账号失败，请重试');
          return;
        }

        if (this.$router) {
                // 拼接查询参数
                const queryParams = new URLSearchParams({
                  orderId: this.orderId,
                  orderAmount: this.urlAmount
                }).toString();
                this.$router.push(`/wait?${queryParams}`);
            }

      },
      startCheckOrder() {
        this.setStatus('loading', '正在获取待充值账号，请稍后');
        // 判断是否为本机地址
         const originUrl= 'http://localhost:5010';
         const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname);
         const checkUrl = isLocal 
            ? `${originUrl}/api/res/pay.order/check.order` 
            : `${window.location.origin}/api/res/pay.order/check.order`;

         const intervalId = setInterval(async () => {
          this.checkOrderCount++;
          try {
            // 使用 post 方法访问接口并携带参数
            const response = await axios.post(checkUrl, {
              orderId: this.orderId,
            });
            this.orderStatus = response.data.data.orderStatus;
            this.message = response.data.data.message;
            if (response.data.data.orderStatus >= 2) {
              this.inputTarget = response.data.data.message;
              //this.nextRul = response.data.data.payUrl;
              clearInterval(intervalId);
              this.setStatus('success', '获取成功！点击复制并跳转，跳转后在充值过程中将待充值账号粘贴在相应位置');
            } 
            // else if (response.data.data.orderStatus > 2) {
            //   clearInterval(intervalId);
            //   this.isLoading = false; // 循环终止时隐藏 loading
            //   window.location.href = '/RechargePage.vue';
            // } 
          } catch (error) {
            console.error('访问 check.order 接口失败:', error);
          }
          if (this.checkOrderCount >= 20) {
              clearInterval(intervalId);
              this.setStatus('timeout', '获取超时，系统可能繁忙，请重新操作');
            }
        }, 3000);
      },
      retryOperation() {
        // this.checkOrderCount = 0;
        // this.showRetryButton = false;
        // this.orderStatus = -1;
        // this.tipMessage = '';
        // this.startCheckOrder();
           // 假设使用 Vue Router 进行页面跳转
           if (this.$router) {
                // 拼接查询参数
                const queryParams = new URLSearchParams({
                    gameid: this.gameid,
                    id: this.id,
                    paychannelid: this.payChannelId
                }).toString();
                this.$router.push(`/amountcyselect?${queryParams}`);
            }
      }
    }
  };
  </script>
  
  <style scoped>
  .status-img {
    width: 200px;
    height: auto;
  }
  
  /* .status-img.loading {
    animation: rotate 2s linear infinite; 只有loading状态才旋转
  } */
  
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .amount-input-container {
    background: #f5f5f5;
    min-height: 100vh;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
  /* 顶部导航栏 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
}

.back-icon, .placeholder {
  width: 24px;
  height: 24px;
}

.back-icon {
  cursor: pointer;
}

.title {
  font-size: 17px;
  font-weight: 600;
  color: #000;
  flex: 1;
  text-align: center;
}

.content-container {
  margin: 0 auto;
  padding: 16px;
}
.content {
  background: #fff;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0px 3px 6px 0px #232B321A;
}
.status-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.tip-message {
  margin: 0 0 20px 0;
  font-size: 16px;
  padding: 12px;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
}

/* 不同状态的样式 */
.tip-message.loading {
  color: #333;
}

.tip-message.success {
  color: #3FCA71;
}

.tip-message.error {
  color: #E4441C;
}

.tip-message.timeout {
  color: #E9B31C;
}
  .input-group {
    margin-bottom: 15px;
  }
  .input-group label {
    display: block;
    margin-bottom: 5px;
    color: #000;
    font-weight: 600;
    font-size: 1.2rem;
  }
  .input-group input {
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 10px;
    font-size: 1rem;
    background-color: #f5f5f5;
    color: #000 !important;
  }
  
  .input-group input:focus {
    color: #000 !important;
    outline: none;
    border-color: #3F9FFF;
  }
  
  .input-group input:disabled {
    color: #666 !important;
    background-color: #e9ecef;
  }
  .submit-button {
    background: #3F9FFF;
    color: #fff;
    padding: 16px 20px;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    font-weight: 500;
    font-size: 0.8rem;
    font-size: 1rem;
    width: 80%;
  }
  .submit-button:hover {
    background: #2e86d9;
  }
  .disabled-button {
    background: #cccccc;
    cursor: not-allowed;
  }
  .use-instructions {
    margin-top: 10px;
    padding: 16px;
    border-radius: 16px;
  }
  .use-instructions-title {
    font-size: 18px;
    font-weight: 600;
    color: #000;
  }
     .use-instructions-content {
     font-size: 14px;
     color: #000;
   }
   
       .instruction-swipe {
      height: 480px;
      border-radius: 12px;
      overflow: hidden;
    }
   
       .instruction-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding:0 10px 15px 10px;
    }
   
   .instruction-step {
     font-size: 14px;
     font-weight: 500;
     color: #333;
     margin-bottom: 10px;
   }
   
       .instruction-img {
      width: 100%;
      max-width: 350px;
      height: auto;
      max-height: 350px;
      object-fit: contain;
      margin-bottom: 15px;
      border-radius: 8px;
    }
   
       .instruction-text {
      font-size: 14px;
      color: #333;
      text-align: center;
      line-height: 1.4;
      max-width: 350px;
      margin-top: 10px;
    }
    
    /* 覆盖 Vant 轮播指示器样式 */
    .instruction-swipe :deep(.van-swipe__indicator) {
      width: 10px;
      height: 10px;
      background-color: #666;
      border-radius: 50%;
    }
    
    .instruction-swipe :deep(.van-swipe__indicator--active) {
      background-color: #3f9fff;
      width: 10px;
      height: 10px;
    }
    
    .instruction-swipe :deep(.van-swipe__indicators) {
      bottom: 15px;
    }
   
  </style>